import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function ATypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList A:', vocaList);
  return (
    <div style={{ width: '100%', paddingBottom: '15px' }}>
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
            marginBottom: `${config?.spacing * Spacing_Base}px`,
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                height: 'auto',
                width: '100%',
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                fontFamily: "'Pretendard', Arial, sans-serif",
                display: 'grid',
                gridTemplateColumns: '1.2fr 4.5fr 4.5fr',
                justifyContent: 'space-between',
                alignItems: 'start',
              }}
            >
              <div style={{ minWidth: '10px' }}>{startNo + idx}.</div>
              {(tab === PAPER_TABS.TEST_PAPER ||
                tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                <div
                  style={{
                    display: 'flex',
                    paddingRight: '2px',
                    fontFamily: "'Pretendard', Arial, sans-serif",
                  }}
                >
                  {voca.question}
                </div>
              )}
              <div
                style={{
                  minWidth: '90px',
                  minHeight: '18px',
                  textAlign: tab === PAPER_TABS.ANSWER ? 'left' : 'center',
                  wordBreak: 'break-all',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                <div
                  style={{
                    minHeight: '15px',
                    fontFamily: "'Pretendard', Arial, sans-serif",
                  }}
                >
                  {tab === PAPER_TABS.TEST_PAPER && ''}
                  {(tab === PAPER_TABS.ANSWER_TEST_PAPER ||
                    tab === PAPER_TABS.ANSWER) &&
                    strParse(voca.answer)}
                </div>
                {(tab === PAPER_TABS.TEST_PAPER ||
                  tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                  <div
                    style={{
                      borderBottom: '1px solid #000',
                      width: '100%',
                      minWidth: '100px',
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ATypeTestRow.propTypes = {
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
};

export default ATypeTestRow;
